(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oversized-size-warning"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('oversized-size-warning')) {
    customElements.define('oversized-size-warning', class extends HTMLElement {
      connectedCallback() {
        if (this.installed) return;
        this.installed = true;
        this.hostForm = this.closest('product-form');
        this.dialog = this.querySelector('dialog');
        if (!this.hostForm || !this.dialog.showModal) return;
        this.intercept = (event) => {
          if (this.confirmed) return;
          const submitter = event.submitter || this.hostForm.querySelector('[type="submit"]');
          if (submitter?.disabled || submitter?.getAttribute('aria-disabled') === 'true') return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.pendingForm = event.target;
          this.submitter = submitter;
          this.dialog.showModal();
        };
        this.hostForm.addEventListener('submit', this.intercept, true);
        const close = () => this.dialog.close();
        this.querySelector('.oversized-warning__close').addEventListener('click', close);
        this.querySelector('.oversized-warning__back').addEventListener('click', close);
        this.querySelector('.oversized-warning__confirm').addEventListener('click', () => {
          this.dialog.close();
          if (!this.pendingForm?.isConnected) return;
          this.confirmed = true;
          try { this.pendingForm.requestSubmit(this.submitter); }
          finally { this.confirmed = false; }
        });
        this.querySelector('details').addEventListener('toggle', (event) => {
          if (!event.target.open || this.chartLoaded) return;
          const source = this.querySelector('template').content;
          const tables = [...source.querySelectorAll('table')];
          const table = tables.find(table => /(?:XS|XL|Breite|Länge|Width|Length)/i.test(table.textContent)) || tables[0];
          const target = this.querySelector('.oversized-warning__chart');
          if (table) {
            target.append(table.cloneNode(true));
            let note = table.parentElement?.nextElementSibling;
            if (!note || !/(?:cm|Toleranz|tolerance)/i.test(note.textContent)) note = table.nextElementSibling;
            if (note && /(?:cm|Toleranz|tolerance)/i.test(note.textContent)) target.append(note.cloneNode(true));
          } else {
            target.append(source.cloneNode(true));
          }
          this.chartLoaded = true;
        });
      }
      disconnectedCallback() {
        this.hostForm?.removeEventListener('submit', this.intercept, true);
        this.dialog?.close();
        this.installed = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
